export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly body: string
  ) {
    super(`API error (${status})`)
    this.name = 'ApiError'
  }
}

export class TimeoutError extends Error {
  constructor(message = 'Polling timed out') {
    super(message)
    this.name = 'TimeoutError'
  }
}

export class AuthExpiredError extends Error {
  constructor(errorMessage = "Authentication expired") {
    super(errorMessage)
    this.name = 'AuthExpiredError'
  }
}

export class AuthenticationRequiredError extends Error {
  constructor(message = 'Authentication is required.') {
    super(message)
    this.name = 'AuthenticationRequiredError'
  }
}
